<template>
  <a-row :gutter="16">
    <a-col :xxl="4" :xl="6" :lg="8" :md="12">
      <a-range-picker v-model:value="queryForm.daterange" :locale="locale" value-format="YYYY-MM-DD"
        style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.orgid" :options="qorgs" :filter-option="$filters.filterOption" show-search
        style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.type" :options="qtypes" style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.state" :options="qstates" style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-button type="primary" @click="getData">查询</a-button>
    </a-col>
  </a-row>
  <div class="d-flex justify-space-between align-center mb-2 mt-2">
    <a-space>
      <a-button type="link" @click="getData">刷新数据</a-button>
    </a-space>
    <a-space>
      <a-dropdown>
        <template #overlay>
          <a-menu>
            <a-menu-item @click="exportselected" :disabled="selectedRowKeys.length === 0">导出勾选</a-menu-item>
            <a-menu-item @click="exportall">导出所有页</a-menu-item>
            <a-menu-item @click="exporttask" class="text-error">查看导出任务</a-menu-item>
          </a-menu>
        </template>
        <a-button type="primary">
          导出数据
          <DownOutlined />
        </a-button>
      </a-dropdown>
    </a-space>
  </div>
  <a-table :columns="columns" bordered :data-source="data" :loading="dataLoading" :scroll="{ x: width, y: 600 }"
    :pagination="{
      current: page,
      pageSize: limit,
      total: count,
      showQuickJumper: true,
      showSizeChanger: true,
    }" @change="(pagination) => {
      page = pagination.current;
      limit = pagination.pageSize;
    }" row-key="_id" :row-selection="{
      selectedRowKeys,
      onChange: (keys) => selectedRowKeys = keys
    }">
    <template #bodyCell="{ record, column }">
      <template v-if="column.dataIndex === 'org'">
        {{ getorgname(record.orgid) }}
      </template>
      <template v-if="column.dataIndex === 'type'">
        {{ gettype(record.type) }}
      </template>
      <template v-if="column.dataIndex === 'amount'">
        {{ record.amount }} {{ record.currency }}
      </template>
      <template v-if="column.dataIndex === 'supplier'">
        {{ getsupplier(record.supplierid) || '-' }}
      </template>
      <template v-if="column.dataIndex === 'attachments1'">
        <a v-if="record.attachments1 > 0" href="javascript:;" class="underline"
          @click="showupload(record._id, '1', '附件')">
          查看
        </a>
        <span v-else> 无 </span>
      </template>
      <template v-if="column.dataIndex === 'remark'">
        {{ record.remark }}
      </template>
      <template v-if="column.dataIndex === 'verify_state'">
        <a-tag v-if="record.verify_state === 1" color="warning">待审核</a-tag>
        <a-tag v-else-if="record.verify_state === 2" color="success">审核通过</a-tag>
        <a-tag v-else-if="record.verify_state === -1" color="error">审核驳回</a-tag>
        <a-space v-if="record.verify_state === 1">
          <a-popconfirm placement="left" title="审核通过？" @confirm="pass(record._id)">
            <a href="javascript:;" class="underline text-success"> 通过 </a>
          </a-popconfirm>
          <a-popconfirm placement="left" title="审核驳回？" @confirm="reject(record._id)">
            <a href="javascript:;" class="underline text-error"> 驳回 </a>
          </a-popconfirm>
        </a-space>
      </template>
      <template v-if="column.dataIndex === 'pay_state'">
        <a-tag v-if="record.pay_state === 0" color="processing">待支付</a-tag>
        <a-tag v-else-if="record.pay_state === 1" color="success">已支付</a-tag>
        <span v-else>-</span>
      </template>
      <template v-if="column.dataIndex === 'pay_time'">
        {{ record.pay_time || '-' }}
      </template>
      <template v-if="column.dataIndex === 'attachments2'">
        <a v-if="record.attachments2 > 0" href="javascript:;" class="underline"
          @click="showupload(record._id, '2', '支付水单')">
          查看
        </a>
        <a v-else href="javascript:;" class="underline text-warning" @click="showupload(record._id, '2', '支付水单')">
          上传
        </a>
      </template>
      <template v-if="column.dataIndex === 'pay_remark'">
        <a-space direction="vertical">
          <template v-if="editremarkdata._id === record._id">
            <a-textarea v-model:value="editremarkdata.pay_remark" placeholder="备注"
              :auto-size="{ minRows: 5, maxRows: 5 }" />
            <a-space>
              <a href="javascript:;" class="text-success underline" @click="saveRemark">
                保存
              </a>
              <a href="javascript:;" class="text-gray underline" @click="() => editremarkdata = {}">
                取消
              </a>
            </a-space>
          </template>
          <template v-else>
            {{ record.pay_remark }}
            <a href="javascript:;" class="underline" @click="editRemark(record)">
              编辑
            </a>
          </template>
        </a-space>
      </template>
      <template v-if="column.dataIndex === 'operation'">
        <a-space>
          <a-button v-if="record.pay_state === 0" type="link" danger @click="showverify(record)">
            核销支付
          </a-button>
        </a-space>
      </template>
    </template>
  </a-table>
  <a-modal v-model:visible="verifyModal" title="核销支付" @ok="verifypay" ok-text="确认" cancel-text="取消"
    :confirm-loading="verifying" :cancel-button-props="{ disabled: verifying }" :maskClosable="!verifying"
    :closable="!verifying">
    <a-form ref="verifyFormRef" name="verifyForm" :model="verifyForm" :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }" autocomplete="off">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item label="商户">
            {{ verifyForm.org }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="费用类型">
            {{ verifyForm.type }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="支付金额">
            {{ verifyForm.amount }}
          </a-form-item>
        </a-col>
        <a-col :span="24" v-if="verifyForm.supplier">
          <a-form-item label="供应商" name="supplier">
            {{ verifyForm.supplier }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="支付时间" name="pay_time" :rules="[{ required: true, message: '请选择支付时间' }]">
            <a-date-picker v-model:value="verifyForm.pay_time" :locale="locale" :show-now="true"
              :show-time="{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }" :show-today="true"
              value-format="YYYY-MM-DD HH:mm:ss" placeholder="支付时间" style="width:100%" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="备注" name="pay_remark">
            <a-textarea v-model:value="verifyForm.pay_remark" placeholder="备注" :disabled="verifying"
              :auto-size="{ minRows: 2, maxRows: 2 }">
            </a-textarea>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
  <a-modal v-model:visible="attachmentModal" :title="attachmentTitle" :footer="false"
    @cancel="() => attachmentModal = false" :maskClosable="!uploading" :closable="!uploading" width="750px">
    <a-table :columns="acolumns" bordered :data-source="attachments" :loading="dataLoading"
      :scroll="{ x: awidth, y: 600 }" :pagination="false">
      <template #title>
        <a-upload v-if="attachment_type === '2'" :showUploadList="false" :disabled="uploading" multiple
          :before-upload="beforeUpload" accept=".jpg,.jpeg,.png">
          <a-space>
            <a-button type="link" :disabled="uploading"> 选择文件 </a-button>
            <a-button type="link" :disabled="fileList.length === 0" :loading="uploading" @click.stop="handleUpload">
              {{ uploading ? '正在上传' : '开始上传' }}
            </a-button>
          </a-space>
        </a-upload>
        <a-list v-if="fileList.length > 0" :data-source="fileList" :loading="uploading" item-layout="horizontal"
          size="small">
          <template #renderItem="{ item, index }">
            <a-list-item>
              <template #extra>
                <a-space>
                  <a-tag v-if="item.status === 'uploading'" color="processing">
                    正在上传
                  </a-tag>
                  <a-tag v-else-if="item.status === 'success'" color="success">
                    上传成功
                  </a-tag>
                  <a-tag v-else-if="item.status === 'error'" color="error">
                    上传失败
                  </a-tag>
                  <a-tag v-else> 等待上传 </a-tag>
                  <a-button type="link" danger @click="removeFile(index)" :disabled="uploading" size="small">
                    删除
                  </a-button>
                </a-space>
              </template>
              <template #actions>
              </template>
              {{ item.name }}
            </a-list-item>
          </template>
        </a-list>
      </template>
      <template #bodyCell="{ record, column }">
        <template v-if="column.dataIndex === 'originalname'">
          <a href="javascript:;" @click="downloadfile(record)">{{ record.originalname }}</a>
        </template>
        <template v-if="column.dataIndex === 'operation'">
          <a-space>
            <a href="javascript:;" class="text-info" @click="previewattachment(record)">预览</a>
            <a-popconfirm v-if="attachment_type === '2'" title="确定要删除?" @confirm="removeattachment(record._id)"
              placement="left">
              <a href="javascript:;" class="text-error">删除</a>
            </a-popconfirm>
          </a-space>
        </template>
      </template>
    </a-table>
  </a-modal>
  <Download ref="downloadRef" />
</template>
<script setup>
import dayjs from "dayjs";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import { DownOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import Download from "@/components/download.vue";
import { ref, watch, computed, onMounted, getCurrentInstance, } from "vue";
import _ from "underscore";
const columns = [
  { title: "商户名称", dataIndex: "org", width: 150 },
  { title: "费用类型", dataIndex: "type", width: 100 },
  { title: "支付金额", dataIndex: "amount", width: 120 },
  { title: "要求支付时间", dataIndex: "expect_pay_time", width: 120 },
  { title: "供应商", dataIndex: "supplier", width: 120 },
  { title: "附件", dataIndex: "attachments1", width: 100 },
  { title: "备注", dataIndex: "remark", width: 200 },
  { title: "审核状态", dataIndex: "verify_state", width: 100 },
  { title: "支付状态", dataIndex: "pay_state", width: 100 },
  { title: "实际支付时间", dataIndex: "pay_time", width: 120 },
  { title: "支付水单", dataIndex: "attachments2", width: 100 },
  { title: "支付备注", dataIndex: "pay_remark", width: 200 },
  { title: "创建时间", dataIndex: "create_time", width: 120 },
  { title: "操作", dataIndex: "operation", width: 120, fixed: "right" },
];
const acolumns = [
  { title: "文件名", dataIndex: "originalname", width: 150 },
  { title: "上传时间", dataIndex: "create_time", width: 120 },
  { title: "上传人", dataIndex: "create_by", width: 100 },
  { title: "操作", dataIndex: "operation", width: 100 },
]
const { proxy } = getCurrentInstance();
const verifyFormRef = ref();
const downloadRef = ref();

const queryForm = ref({
  daterange: ["", ""],
  orgid: "ALL",
  type: "ALL",
  state: "ALL",
});
const dataLoading = ref(false);
const page = ref(1);
const limit = ref(20);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const selectedRowKeys = ref([]);
const orgs = ref([]);
const types = ref([]);
const suppliers = ref([]);
const attachmentModal = ref(false);
const attachmentTitle = ref('');
const payreqid = ref('');
const attachment_type = ref('');
const uploading = ref(false);
const attachments = ref([]);
const fileList = ref([]);
const verifyForm = ref({});
const verifyModal = ref(false);
const verifying = ref(false);
const editremarkdata = ref({});

const qtypes = computed(() => {
  return [
    { value: 'ALL', label: '全部类型' },
    ...types.value,
  ]
});
const sorgs = computed(() => orgs.value.map(n => ({ value: n._id, label: n.name })));
const qorgs = computed(() => {
  return [
    { value: 'ALL', label: '全部商户' },
    ...sorgs.value,
  ]
});
const awidth = computed(() => proxy.$utils.twidth(acolumns));
const width = computed(() => proxy.$utils.twidth(columns));
const states = computed(() => [
  { value: "1", label: "待审核" },
  { value: "2", label: "审核通过(待支付)" },
  { value: "-1", label: "审核驳回" },
  { value: "3", label: "已支付" },
]);
const qstates = computed(() => {
  return [
    { value: 'ALL', label: '全部' },
    ...states.value,
  ]
});

watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});

onMounted(() => {
  getData();
});

const getData = () => {
  selectedRowKeys.value = [];
  dataLoading.value = true;
  proxy.$api.doAPI("/payreq/list", { page: page.value, limit: limit.value, ...queryForm.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = _.map(res.data.list, n => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, "YYYY-MM-DD HH:mm:ss"),
        };
      });
      length.value = res.data.length;
      count.value = res.data.count;
      if (length.value > 0 && page.value > length.value) page.value = 1;
      orgs.value = res.data.orgs;
      types.value = res.data.types;
      suppliers.value = res.data.suppliers;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const editRemark = (item) => {
  editremarkdata.value = {
    _id: item._id,
    pay_remark: item.pay_remark,
  };
}
const saveRemark = () => {
  if (!editremarkdata.value.remark) return message.error("备注不能为空");
  dataLoading.value = true;
  proxy.$api.doAPI("/payreq/saveremark", editremarkdata.value).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      editremarkdata.value = {};
      getData();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
}
const downloadfile = (record) => {
  if (record.remoteurl) {
    proxy.$utils.download(record.remoteurl, record.originalname);
  }
}
const showupload = (id, type, title) => {
  payreqid.value = id;
  attachment_type.value = type;
  attachmentTitle.value = title;
  showattachments();
}
const showattachments = () => {
  dataLoading.value = true;
  proxy.$api.doAPI("/payreq/attachments", { payreqid: payreqid.value, type: attachment_type.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      attachments.value = _.map(res.data.list, (n) => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, "YYYY-MM-DD HH:mm:ss"),
        };
      });
      fileList.value = fileList.value.filter(n => n.status === "error");
      attachmentModal.value = true;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
}
const removeattachment = (_id) => {
  dataLoading.value = true;
  proxy.$api.doAPI("/payreq/removeattachment", { _id }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      showattachments();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
}
const previewattachment = (item) => {
  proxy.$viewerApi({ images: [item.remoteurl] });
}
const beforeUpload = file => {
  fileList.value = [...fileList.value, { file, name: file.name, status: "waiting" }];
  return false;
}
const removeFile = (index) => {
  fileList.value.splice(index, 1);
}
const handleUpload = async () => {
  console.log('handleUpload');
  uploading.value = true;
  for (let i = 0; i < fileList.value.length; i++) {
    if (fileList.value[i].status === "uploading" || fileList.value[i].status === "success") continue;
    fileList.value[i].status = "uploading";
    let success = await doUpload(fileList.value[i].file, payreqid.value);
    console.log({ success });
    if (success) fileList.value[i].status = "success";
    else fileList.value[i].status = "error";
    console.log('handleUpload', i, fileList.value[i]);
  }
  uploading.value = false;
  showattachments();
}
const doUpload = async (file, id) => {
  const slicefiles = proxy.$utils.sliceFile(file.size);
  const faid = proxy.$utils.uuid();
  for (let i = 0; i < slicefiles.length; i++) {
    let slicefile = slicefiles[i];
    const formData = new FormData();
    if (slicefile.chunks > 1) {
      let _file = file.slice(slicefile.from, slicefile.to);
      formData.set("file", _file);
    } else {
      formData.set("file", file);
    }
    formData.set("faid", faid);
    formData.set("chunk", slicefile.chunk);
    formData.set("chunks", slicefile.chunks);
    formData.set("originalname", file.name);
    formData.set("payreqid", id);
    formData.set("type", 2);
    try {
      let res = await proxy.$api.doUpload("/payreq/plupload", formData);
      if (res.code === 0) {
        if (slicefile.chunk + 1 === slicefile.chunks) {
          return true;
        }
      } else {
        message.error(res.msg);
        return false;
      }
    } catch (e) {
      console.error(e);
      message.error(e.message);
      return false;
    }
  }
}
const pass = (_id) => {
  dataLoading.value = true;
  proxy.$api.doAPI("/payreq/pass", { _id }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      getData();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
}
const reject = (_id) => {
  dataLoading.value = true;
  proxy.$api.doAPI("/payreq/reject", { _id }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      getData();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
}
const showverify = (item) => {
  verifyForm.value = {
    _id: item._id,
    org: getorgname(item.orgid),
    type: gettype(item.type),
    supplier: getsupplier(item.supplierid),
    amount: item.amount,
    currency: item.currency,
    pay_time: proxy.$dateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss'),
    pay_remark: '',
  };
  verifyModal.value = true;
}
const verifypay = async () => {
  try {
    await verifyFormRef.value.validateFields();
    verifying.value = true;
    proxy.$api.doAPI("/payreq/verifypay", { dataForm: verifyForm.value }).then((res) => {
      verifying.value = false;
      if (res.code === 0) {
        message.success("核销成功");
        verifyModal.value = false;
        getData();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      verifying.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
}
const exportdata = (ids) => {
  return new Promise(resolve => {
    dataLoading.value = true;
    proxy.$api.doAPI("/payreq/list", { ...queryForm.value, ids, action: "download" }).then((res) => {
      dataLoading.value = false;
      resolve(true);
    }).catch((err) => {
      dataLoading.value = false;
      resolve(false);
      console.error(err);
    });
  })
}
const exportselected = () => {
  exportdata(selectedRowKeys.value).then((ok) => { if (ok) exporttask() });
}
const exportall = () => {
  exportdata([]).then((ok) => { if (ok) exporttask() });
}
const exporttask = () => {
  downloadRef.value.showDownload({ title: "导出代付申请", type: "payreq" });
}
const getorgname = (value) => {
  return _.findWhere(orgs.value, { _id: value })?.name;
}
const gettype = (value) => {
  return _.findWhere(types.value, { value })?.label;
}
const getsupplier = (value) => {
  let supplier = _.findWhere(suppliers.value, { _id: value });
  return supplier?.shortname || supplier?.name;
}
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

p {
  margin: 0;
  padding: 0;
}

.static {
  padding: 20px;
  background-color: #f2f2f2;
  margin-bottom: 10px;
}
</style>